/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { Changeset } from "ember-changeset";
import { task } from "ember-concurrency";
import type Medic from "parog-web/models/medic";
import type OncoToulouseInfoMessage from "parog-web/models/onco-toulouse-info-message";
import type Patient from "parog-web/models/patient";
import type SemeiaSessionService from "parog-web/services/session";
import type TermsOfUseService from "parog-web/services/terms-of-use";

import styles from "./index.module.css";

interface Signature {
  Args: {
    oncoToulouseInfoMessage?: OncoToulouseInfoMessage;
  };
}

export default class TermsOfUseComponent extends Component<Signature["Args"]> {
  styles = styles;

  @service declare termsOfUse: TermsOfUseService;
  @service declare session: SemeiaSessionService;

  get changeset() {
    // Memoization :
    Object.defineProperty(this, "changeset", {
      value: Changeset({}),
      writable: false
    });

    return this.changeset;
  }

  get user() {
    return this.session.medic || (this.session.patient as Medic | Patient);
  }

  payloadKey = "acceptTermsOfUse";

  get acceptsTermsOfUse() {
    return this.changeset.get(this.payloadKey);
  }

  get isButtonDisabled() {
    return !this.acceptsTermsOfUse || this.saveTask.isRunning;
  }

  saveTask = task(async () => {
    if (!this.acceptsTermsOfUse) return;

    this.user.set("acceptedTermsOfUseVersion", this.termsOfUse.currentVersion);
    await this.user.save();

    this.termsOfUse.continueNavigationAfterAcceptingTermsOfUse();
  });

  get shouldAcceptLatestTermsOfUseVersion() {
    return Boolean(this.user) && !this.user.isAcceptedTermsOfUse;
  }

  get alreadyAcceptedAnyTermsOfUse() {
    return this.user.acceptedTermsOfUseVersion;
  }

  get limitDate() {
    return this.termsOfUse.limitDate;
  }

  get shouldShowOncoToulouseSection(): boolean {
    return (
      (this.session.patient?.healthCentre?.oncoToulouse &&
        Boolean(this.args.oncoToulouseInfoMessage)) ||
      false
    );
  }
}
